import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GlobalLoadingState {
  isLoading: boolean;
  message: string;
  /** Ref-count per loadingId so overlapping module loads do not leave the backdrop stuck */
  activeLoadingCounts: Record<string, number>;
}

const initialState: GlobalLoadingState = {
  isLoading: false,
  message: 'Đang tải...',
  activeLoadingCounts: {},
};

const syncIsLoading = (state: GlobalLoadingState) => {
  state.isLoading = Object.values(state.activeLoadingCounts).some((count) => count > 0);
};

const globalLoadingSlice = createSlice({
  name: 'globalLoading',
  initialState,
  reducers: {
    startLoading: (state, action: PayloadAction<{ message?: string; loadingId?: string }>) => {
      const loadingId = action.payload.loadingId || '__default__';
      state.activeLoadingCounts[loadingId] = (state.activeLoadingCounts[loadingId] || 0) + 1;
      if (action.payload.message) {
        state.message = action.payload.message;
      }
      syncIsLoading(state);
    },
    stopLoading: (state, action: PayloadAction<{ loadingId?: string } | undefined>) => {
      const loadingId = action.payload?.loadingId;
      if (loadingId) {
        const next = (state.activeLoadingCounts[loadingId] || 0) - 1;
        if (next <= 0) {
          delete state.activeLoadingCounts[loadingId];
        } else {
          state.activeLoadingCounts[loadingId] = next;
        }
      } else {
        state.activeLoadingCounts = {};
      }
      syncIsLoading(state);
      if (!state.isLoading) {
        state.message = 'Đang tải...';
      }
    },
    setLoadingMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
    },
  },
});

export const { startLoading, stopLoading, setLoadingMessage } = globalLoadingSlice.actions;
export default globalLoadingSlice.reducer;
